export const humanizeList = conjunction => elements => {
  if (elements.length === 0) return "";
  if (elements.length === 1) return elements[0];
  if (elements.length === 2) return elements[0] + " " + conjunction + " " + elements[1];

  return elements.slice(0, -1).join(", ") + ", " + conjunction + " " + elements.slice(-1)
};

